module.exports = __webpack_public_path__ + "img/popular-posts-4.4979bfd8.png";